export class Category {
    $key: string;
    position: number;
    text: string = null;
}


// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/models/category.ts